export enum MessageType {
  ERROR = 'error',
  INFO = 'info',
  REPORT = 'report',
  SUCCESS = 'success',
  WARNING = 'warning',
}
